import { ScreenTypes } from "../enums";
import { calendarRangeRegular, personaliseIcon } from "./icons";
import { ROUTES } from "./paths";

export const TEST_META_DATA =
  '[{"cityName":"Santander, Cantabria, Spain","averagePackagePriceForExperiencing":"$1,700","description":"Santander is a city in the north of Spain that is located on the coast of the Bay of Biscay. ","hotelName":"Eurostars Hotel Real","averageCostOfFood":"$25","averageCostAccommodation":"$180","matchPercentage":"60%","orginatedCity":"Narssarssuaq, Greenland","destinationCity":"","selectedMonth":"June","year":"2024","internationalFlag":false,"numberOfDaysSelected":3,"numberOfExperienceSelected":3,"planTripArray":[{"day":"Day 1","completedFlag":true,"activities":[{"id":"218edb7e-6e20-4d5b-ab13-9816135e29b0","description":"Arrive in Santander and check-in at a boutique hotel in the city center"},{"id":"2e6e01d8-644f-4dc9-8089-1d22d3632421","description":"Visit the Palacio de la Magdalena, a beautiful palace overlooking the Bay of Santander"},{"id":"2dd527a8-b702-4114-ab05-9ce2f86f14da","description":"Enjoy a gluten-free lunch at La Mulata, a restaurant known for its delicious gluten-free options"}]},{"day":"Day 2","completedFlag":true,"activities":[{"id":"254174c6-ccc7-4285-992e-236f1208d52b","description":"Take a hike in the nearby Cabárceno Nature Park, home to over a hundred species of animals from around the world"},{"id":"2ce1a30d-cd51-4150-921b-bce66b0636bc","description":"Attend the Semana Grande festival, which takes place in August and features music, dance, and cultural events"},{"id":"aab4f4ca-5d7d-4b0d-993c-eb6de99f976a","description":"End the day with a relaxing boat ride in the Bay of Santander"}]},{"day":"Day 3","completedFlag":true,"activities":[{"id":"de777f9e-7798-46c0-a465-8524e15a8903","description":"Take a day trip to the Picos de Europa National Park, a stunning natural park with hiking trails and breathtaking views"},{"id":"99ac8dcb-1762-4f10-ac34-60e3f3b0b635","description":"Visit the Altamira Cave, a UNESCO World Heritage site known for its prehistoric rock art"},{"id":"b148574e-f337-4e39-8149-ec64d4ef806e","description":"Enjoy a gluten-free dinner at La Bombi, a restaurant located in the heart of Santander"}]}],"climate":[{"id":0,"data":"Rainforest","check":false},{"id":1,"data":"Tropical","check":true},{"id":2,"data":"Oceanic","check":false},{"id":3,"data":"Mediterranean","check":false},{"id":4,"data":"Desert","check":false},{"id":5,"data":"Grassland","check":false},{"id":6,"data":"Arctic","check":false},{"id":7,"data":"Mountains","check":false},{"id":8,"data":"Rivers","check":false}],"population":[{"id":0,"data":"Big City","check":false},{"id":1,"data":"Urban","check":true},{"id":2,"data":"Suburb","check":false},{"id":3,"data":"Small City","check":false},{"id":4,"data":"Village/Hamlet","check":false},{"id":5,"data":"Rural","check":false},{"id":6,"data":"Remote","check":false}],"experience":[{"id":0,"data":"Historical Sights","check":false},{"id":1,"data":"Nightlife","check":false},{"id":2,"data":"Hiking","check":true},{"id":3,"data":"Festivals","check":true},{"id":4,"data":"Major/Special Events","check":false},{"id":5,"data":"Biking","check":false},{"id":6,"data":"Theme Parks","check":false},{"id":7,"data":"Beaches","check":false},{"id":8,"data":"Nature","check":false},{"id":9,"data":"Boating","check":true},{"id":10,"data":"Fishing","check":false},{"id":11,"data":"Water Sports","check":false}],"budget":[{"id":1,"data":"Economic","check":false,"value":"around $500 per person","symbol":"Economic"},{"id":2,"data":"Luxury","check":true,"value":"around $1000 per person","symbol":"Luxury"},{"id":3,"data":"Ultra luxury","check":false,"value":"around $2500 per person","symbol":"Super Luxury"}],"accomodations":[{"id":1,"data":"Boutique Hotels","check":true},{"id":2,"data":"Large Hotels","check":false},{"id":3,"data":"Motels","check":false},{"id":4,"data":"Bed & Breakfast","check":false},{"id":5,"data":"Guest Houses","check":false},{"id":6,"data":"Home Stays","check":false},{"id":7,"data":"Resorts","check":false},{"id":8,"data":"All-Inclusive","check":true},{"id":9,"data":"Chalets","check":false},{"id":10,"data":"Hostels","check":false},{"id":11,"data":"Cottages","check":false},{"id":12,"data":"Cabins","check":false},{"id":13,"data":"Tiny Homes","check":false},{"id":14,"data":"Trailers","check":false},{"id":15,"data":"Campers & RVs","check":false},{"id":16,"data":"Tents & Yurts","check":false},{"id":17,"data":"Apartments","check":false},{"id":18,"data":"Condos","check":false},{"id":19,"data":"Extended Stay Hotels","check":false},{"id":20,"data":"Boats","check":false}],"foodPreferences":[{"id":1,"data":"Vegetarian","check":false},{"id":2,"data":"Gluten-free","check":true},{"id":3,"data":"Coeliac","check":false},{"id":4,"data":"Dairy-free","check":false},{"id":5,"data":"Lactose-free","check":false},{"id":6,"data":"Vegan","check":false},{"id":7,"data":"Paleo","check":false},{"id":8,"data":"Pescetarian","check":false},{"id":9,"data":"Low FODMAP","check":false},{"id":10,"data":"Keto","check":false},{"id":11,"data":"Halal","check":false},{"id":12,"data":"Kosher","check":false},{"id":13,"data":"Hindu","check":false},{"id":14,"data":"Jain","check":false},{"id":15,"data":"Diabetes","check":false}]}]';

export const TERMS_AND_CONTACT_ARR = [
  // {
  //   id: 4,
  //   icon: circleInfoRegular,
  //   title: "About",
  //   // desc: "Frequently asked questions",
  //   link: ROUTES.AboutUs,
  //   // enumType: ScreenTypes.help,
  // },
  {
    id: 0,
    title: "Get help",
    // link: ROUTES.Faqs,
    link: undefined,
  },
  // {
  //   id: 1,
  //   title: "Contact Us",
  //   link: `${WEB_URL}contact-us`,
  // },
  {
    id: 2,
    title: "Privacy Policy",
    link: ROUTES.PrivacyPolicy,
  },
  {
    id: 3,
    title: "Terms of Service",
    link: ROUTES.Tos,
  },
];

export const SideBarData = [
  // {
  //   id: 1,
  //   icon: "",
  //   title: "For you",
  //   desc: "",
  //   routInfo: ROUTES.ForYou,
  //   enumType: ScreenTypes.ForYou,
  // },
  {
    id: 2,
    icon: calendarRangeRegular,
    title: "My Trips",
    desc: "Upcoming, Past, Saved and Cancelled Trips",
    routInfo: ROUTES.MyTrips,
    enumType: ScreenTypes.MyTrips,
  },
  {
    id: 3,
    icon: personaliseIcon,
    title: "preferences",
    desc: "Budget, food, accomodations, activities and more",
    routInfo: ROUTES.PreviewPreference,
    enumType: ScreenTypes.Preferences,
  },
  // {
  //   id: 4,
  //   icon: circleInfoRegular,
  //   title: "HELP",
  //   desc: "Frequently asked questions",
  //   routInfo: ROUTES.Faqs,
  //   enumType: ScreenTypes.help,
  // },
];

export const FaqSData = [
  {
    id: 1,
    question: "What is zenvoya and how does it work?",
    ans: "zenvoya is an AI language model developed by OpenAI. It works by generating human-like text based on the input it receives. It has been trained on a vast amount of text data and uses patterns and structures within that data to generate relevant and coherent responses.",
  },
  {
    id: 2,
    question: "How do I start a conversation with zenvoya?",
    ans: "To start a conversation with zenvoya, simply type your question or statement into the chat interface. The AI will process your input and generate a response. You can continue the conversation by providing further input or asking follow-up questions.",
  },
  {
    id: 3,
    question: "What types of questions or tasks can zenvoya help with?",
    ans: "zenvoya can assist with a wide range of questions and tasks, including answering factual questions, providing explanations, offering creative writing help, giving recommendations, summarizing text, and more. However, it may have limitations in understanding highly specialized or context-specific queries.",
  },
  {
    id: 4,
    question: "Are there any limitations to what zenvoya can do?",
    ans: "Yes, zenvoya has limitations. It may provide incorrect or nonsensical answers, especially if the input is ambiguous or outside its training scope. It does not have real-time information or access to personal data unless shared during the conversation. Additionally, it cannot perform physical tasks or interact with the real world",
  },
  {
    id: 5,
    question: "How does zenvoya handle my privacy and data?",
    ans: "OpenAI takes privacy and data security seriously. Conversations with zenvoya are typically stored for the purpose of improving the model, but personally identifiable information should not be shared in the conversation. Users should avoid sharing sensitive information to protect their privacy.",
  },
  {
    id: 6,
    question: "Can zenvoya understand and respond in multiple languages?",
    ans: "Yes, zenvoya can understand and respond in multiple languages. However, its proficiency may vary depending on the language and the complexity of the query. It performs best in English, as that is the primary language it was trained on.",
  },
  {
    id: 7,
    question: "How can I find a previous search I created?",
    ans: "",
  },
  {
    id: 8,
    question: "How can I provide feedback or report issues?",
    ans: "",
  },
];

export const FlightData = [
  {
    id: 1,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
  {
    id: 2,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
  {
    id: 3,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },

  {
    id: 4,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
  {
    id: 5,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
  {
    id: 6,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
  {
    id: 7,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },

  {
    id: 8,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
  },
];

export const TodayItineraryData = {
  id: 1,
  day: "Today",
  date: "MON AUG 13",
  cityName: "Barcelona",
  cityHighlights: "Explore the Gothic Quarter and city center.",
  dayItinerary: [
    {
      id: 1,
      title: "Morning",
      description: "Visit the Gothic Quarter, including the Barcelona Cathedral and Plaça Reial.",
    },
    {
      id: 1,
      title: "Afternoon",
      description: "Wander through the bustling La Rambla and visit the Boqueria Market for some local treats.",
    },
    {
      id: 1,
      title: "Evening",
      description: "Relax at a café in Plaça de Catalunya and enjoy the city's vibrant atmosphere.",
    },
  ],
  nearByActivity: [
    {
      id: 1,
      actName: "Restaurants",
      actTitle: "Dos Catedrales",
      actDesc: "Great daytime eatery with local fare.",
      distance: "300 meters away",
    },
    {
      id: 2,
      actName: "Activities",
      actTitle: "AMC 16 Movies",
      actDesc: "Current blockbuster films in a luxury space.",
      distance: ".25 miles away",
    },
  ],
};

export const NotificationData = [
  // {
  //   id: 1,
  //   notificationType: "flight_delay",
  //   title: "FLIGHT DELAYS",
  //   notificationDetails:
  //     "Your flight BA817 from Barcelona to London has been delayed by 72 minutes. New departure time is 7:34PM on AUG 18.",
  //   bgImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/pexels-pixabay-46148.jpg",
  //   weatherType: "flight",
  //   showNotification: true,
  //   notificationIcon: "",
  // },
  {
    id: 2,
    notificationType: "Weather",
    title: "Weather Advisory",
    notificationDetails:
      "Add plain language description of error and how to recover from it here, using up to 100 characters.",
    bgImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/pexels-photo-1162252.png",
    weatherType: "hot",
    showNotification: false,
    notificationIcon: "",
  },
];

export const options = [
  {
    label: "January",
    value: "01",
  },
  {
    label: "February",
    value: "02",
  },
  {
    label: "March",
    value: "03",
  },
  {
    label: "April",
    value: "04",
  },
  {
    label: "May",
    value: "05",
  },
  {
    label: "June",
    value: "06",
  },
  {
    label: "July",
    value: "07",
  },
  {
    label: "August",
    value: "08",
  },
  {
    label: "September",
    value: "09",
  },
  {
    label: "October",
    value: "10",
  },
  {
    label: "November",
    value: "11",
  },
  {
    label: "December",
    value: "12",
  },
];
export const gender = ["Male", "Female"];
export const mealPref = ["No Beef Meal", "Vegetarian ", "Japanese", "Seasonal fresh fruit"];
export const needs = [
  "Bassinet / cot",
  "Checking a wheelchair",
  "Blind",
  "Wheelchair service required",
  "Deaf",
  "Cognitive Disability",
  "Other Disability requiring assistance",
];

// export const countryCode = ["+1", "+91", "+112", "+95"];
export const countryCode = [
  {
    label: "+1",
    countryCode: "US",
  },
  {
    label: "+91",
    countryCode: "IN",
  },
];

export const programName = ["Seat upgrade", "Extra baggage"];

export const WeatherDelayData = [
  {
    id: 1,
    day: "Today",
    date: "MON AUG 13",
    cityName: "Barcelona",
    cityHighlights: "Explore the Gothic Quarter and city center.",
    dayItinerary: [
      {
        id: 1,
        title: "Morning",
        description: "Visit the Gothic Quarter, including the Barcelona Cathedral and Plaça Reial.",
        removed: false,
      },
      {
        id: 2,
        title: "Afternoon",
        description: "Wander through the bustling La Rambla and visit the Boqueria Market for some local treats.",
        removed: false,
      },
      {
        id: 3,
        title: "Evening",
        description: "Relax at a café in Plaça de Catalunya and enjoy the city's vibrant atmosphere.",
        removed: false,
      },
    ],
  },
  {
    id: 2,
    day: "Today",
    date: "MON AUG 13",
    cityName: "Barcelona",
    cityHighlights: "Explore the Gothic Quarter and city center.",
    dayItinerary: [
      {
        id: 4,
        title: "Morning",
        description: "Visit the Gothic Quarter, including the Barcelona Cathedral and Plaça Reial.",
        removed: false,
      },
      {
        id: 5,
        title: "Afternoon",
        description: "Wander through the bustling La Rambla and visit the Boqueria Market for some local treats.",
        removed: true,
      },
      {
        id: 6,
        title: "Evening",
        description: "Relax at a café in Plaça de Catalunya and enjoy the city's vibrant atmosphere.",
        removed: false,
      },
    ],
  },
];

export const FlightDelayList = [
  {
    id: 1,
    startTime: "11:45am",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "AMS",
    stopTime: "12h 14min",
    airports: "BCN - LHR",
    flightCost: "0",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
  },
  {
    id: 2,
    startTime: "12:15pm",
    endTime: "2:20pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "",
    stopTime: "2h 9min",
    airports: "BCN - LHR",
    flightCost: "104",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
  },
  {
    id: 3,
    startTime: "5:32pm",
    endTime: "9:55pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "AMS",
    stopTime: "12h 14min",
    airports: "BCN - LHR",
    flightCost: "0",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/lufthansa.jpg",
  },

  {
    id: 4,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
  },
  {
    id: 5,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/lufthansa.jpg",
  },
  {
    id: 6,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
  },
  {
    id: 7,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/lufthansa.jpg",
  },

  {
    id: 8,
    startTime: "9:32pm",
    endTime: "5:15pm",
    flightName: "British Airways",
    stopsInfo: 2,
    stops: "LHR, AMS",
    stopTime: "12h 14min",
    airports: "IAD - BCN",
    flightCost: "1,297",
    flightClass: "ECONOMY",
    flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
  },
];

export const FlightWeatherDelayData = [
  {
    id: 1,
    day: "Today",
    date: "MON AUG 18",
    cityName: "Barcelona",
    cityHighlights: "Explore the Gothic Quarter and city center.",
    flight: false,
    dayItinerary: [
      {
        id: 1,
        title: "Morning",
        description: "Visit the Gothic Quarter, including the Barcelona Cathedral and Plaça Reial.",
        removed: true,
        new: false,
      },
      {
        id: 2,
        title: "Afternoon",
        description: "Wander through the bustling La Rambla and visit the Boqueria Market for some local treats.",
        removed: true,
        new: false,
      },
      {
        id: 3,
        title: "Evening",
        description: "Relax at a café in Plaça de Catalunya and enjoy the city's vibrant atmosphere.",
        removed: false,
        new: false,
      },
    ],
  },
  {
    id: 2,
    day: "Today",
    date: "MON AUG 19",
    cityName: "BARCELONA AND LONDON",
    cityHighlights: "Barcelona (BCN) - London (LHR",
    flight: true,
    dayItinerary: [
      {
        id: 4,
        title: "Morning",
        description: "Visit the Gothic Quarter, including the Barcelona Cathedral and Plaça Reial.",
        removed: false,
        new: false,
      },
      {
        id: 5,
        title: "Afternoon\u00A0\u00A0\u00A0\u00A0LONDON",
        description:
          "Start your day with lunch at the hotel restaurant, then take a walk to the nearby shopping district.",
        removed: true,
        planModifications: [
          "Depart Barcelona Airport (BCN) at 12:15pm",
          "Arrival at London Heathrow Airport (LHR) at 2:20pm",
          "Proceed to check in at your hotel, Marriott Park Central at 2384 Royal Picadilly Boulevard, London",
        ],
        new: true,
      },
      {
        id: 6,
        title: "Evening\u00A0\u00A0\u00A0\u00A0LONDON",
        description: "Relax at a café in Plaça de Catalunya and enjoy the city's vibrant atmosphere.",
        removed: false,
        new: false,
      },
    ],
  },
];

export const FlightNewData = {
  title: "Flight Delays",
  description:
    "Your flight BA817 from Barcelona to London has been delayed by 72 minutes. New departure time is 7:34PM on AUG 18.",
  advisoryType: "flight",
  bgColor: "blue",
  bgImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/flightimage.jpg",
};

export const stepsData = [
  {
    id: 1,
    accordType: "flight",
    date: "Fri Dec 18",
    flightFrom: "Washington DC (IAD)",
    fightTo: "Barcelona (BCN)",
    stepsData: [
      {
        title: "BCN  |  Barcelona Airport",
        airPortCode: "BCN",
        airportName: "Barcelona Airport",
        description: "FRI, AUG 14, 2024 at 12:15pm",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "British Airways",
              flightNumber: "Flight BA415",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "Departure",
              flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
            },
            departure: {
              departure: "Departure",
              departureTime: "10:20 PM",
              flightTime: "Flight time: 8h 17m",
            },
            seats: {
              seats: "seats",
              seatNumb: "24A, 24B, 25A, 25B",
              boardingPasses: "4",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow Airport",
        airPortCode: "LHR",
        airportName: "London Heathrow Airport",
        description: "Saturday, DEC 19, 2024",
        ArrivalOnDiffDate: true,
        layOver: true,
        cardInfo: [
          {
            arrival: {
              arrival: "Arrival",
              arrivalTime: "12:03 PM",
            },
            layover: {
              layover: "Layover",
              arrivalTime: "2h 17m",
            },
          },
        ],
      },
      {
        title: "BCN  |  Barcelona Airport",
        airPortCode: "BCN",
        airportName: "Barcelona Airport",
        description: "Saturday, DEC 19, 2024",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "Lufthansa",
              flightNumber: "Flight LH1707",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "",
              flightImage:
                "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/png-transparent-lufthansa-hd-logo.png",
            },
            departure: {
              departure: "Departure",
              departureTime: "2:20 PM",
              flightTime: "Flight time: 2h",
            },
            seats: {
              seats: "seats",
              seatNumb: "19A, 19B, 19C, 19D",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow Airport",
        airPortCode: "LHR",
        airportName: "London Heathrow Airport",
        description: "FRI, AUG 19, 2024 at 2:20pm",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            arrival: {
              arrival: "Arrival",
              arrivalTime: "12:03 PM",
              destinationImg:
                "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/screenshot_2024-08-22_145427.png",
            },
          },
        ],
      },
    ],
  },
];

export const citiesDataInterface = [
  "Gothic Quarter",
  "Barcelona",
  "Plaça Reial",
  "La Rambla",
  "Boqueria Market",
  "Plaça de Catalunya",
];

export const BookedFlightsInfo = [
  {
    id: 3,
    accordType: "traveler",
    title: "Travelers",
    passengers: {
      adult: "1 Adult",
      child: "2 Children",
      senior: "",
    },
    traveler: [
      {
        name: "SINCLAIR, JESSICA R.",
        gender: "female",
        FF: "Skymiles  |  251-544-1854",
        meal: "Vegetarian",
        email: "sinclairjessica@gmail.com",
        phoneNumber: "+1 (917) 258-4958",
        specialNeeds: ["Bassinet / cot", "Wheelchair service"],
      },
      {
        name: "SINCLAIR, AMANDA B.",
        gender: "female",
        meal: "Vegetarian",
      },
      {
        name: "SINCLAIR, ROBERT B",
        gender: "male",
        meal: "Vegetarian",
        email: "",
        phoneNumber: "",
      },
    ],
  },
];

export const FlightsSearchInfo = [
  {
    id: 1,
    accordType: "flight",
    date: "Fri Dec 18",
    flightFrom: "Washington DC (IAD)",
    fightTo: "Barcelona (BCN)",
    stepsData: [
      {
        title: "IAD |  Washington Dulles International Airport",
        airPortCode: "IAD",
        airportName: "Washington Dulles International Airport",
        description: "Friday, DEC 18, 2024",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "British Airways",
              flightNumber: "Flight BA415",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "Departure",
              flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
            },
            departure: {
              departure: "Departure",
              departureTime: "10:20 PM",
              flightTime: "Flight time: 8h 17m",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow International Airport",
        airPortCode: "LHR",
        airportName: "London Heathrow International Airport",
        description: "Saturday, DEC 19, 2024",
        ArrivalOnDiffDate: true,
        layOver: true,
        cardInfo: [
          {
            arrival: {
              arrival: "Arrival",
              arrivalTime: "12:03 PM",
            },
            layover: {
              layover: "Layover",
              arrivalTime: "2h 17m",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow International Airport",
        airPortCode: "LHR",
        airportName: "London Heathrow International Airport",
        description: "Saturday, DEC 19, 2024",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "Lufthansa",
              flightNumber: "Flight LH1707",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "",
              flightImage:
                "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/png-transparent-lufthansa-hd-logo.png",
            },
            departure: {
              departure: "Departure",
              departureTime: "2:20 PM",
              flightTime: "Flight time: 2h",
            },
          },
        ],
      },
      {
        title: "BCN  |  Barcelona International Airport",
        description: "Saturday, DEC 19, 2024 ",
        airPortCode: "BCN",
        airportName: "Barcelona International Airport",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [{}],
      },
    ],
  },
  {
    id: 1,
    accordType: "flight",
    date: "Fri Dec 18",
    flightFrom: "Washington DC (IAD)",
    fightTo: "Barcelona (BCN)",
    stepsData: [
      {
        title: "IAD |  Washington Dulles International Airport",
        airPortCode: "IAD",
        airportName: "Washington Dulles International Airport",
        description: "Friday, DEC 18, 2024",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "British Airways",
              flightNumber: "Flight BA415",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "Departure",
              flightImage: "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/britishairways.jpg",
            },
            departure: {
              departure: "Departure",
              departureTime: "10:20 PM",
              flightTime: "Flight time: 8h 17m",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow International Airport",
        description: "Saturday, DEC 19, 2024",
        airPortCode: "LHR",
        airportName: "London Heathrow International Airport",
        ArrivalOnDiffDate: true,
        layOver: true,
        cardInfo: [
          {
            arrival: {
              arrival: "Arrival",
              arrivalTime: "12:03 PM",
            },
            layover: {
              layover: "Layover",
              arrivalTime: "2h 17m",
            },
          },
        ],
      },
      {
        title: "LHR  |  London Heathrow International Airport",
        airPortCode: "LHR",
        airportName: "London Heathrow International Airport",
        description: "Saturday, DEC 19, 2024",
        ArrivalOnDiffDate: false,
        layOver: false,
        cardInfo: [
          {
            flightDetails: {
              flightName: "Lufthansa",
              flightNumber: "Flight LH1707",
              bookingRef: "Booking reference: 4DF7VD",
              Departure: "",
              flightImage:
                "https://zenvoya-uploads-dev-test.s3.amazonaws.com/profile/png-transparent-lufthansa-hd-logo.png",
            },
            departure: {
              departure: "Departure",
              departureTime: "2:20 PM",
              flightTime: "Flight time: 2h",
            },
          },
        ],
      },
      {
        title: "BCN  |  Barcelona International Airport",
        airPortCode: "BCN",
        airportName: "Barcelona International Airport",
        description: "Saturday, DEC 19, 2024 ",
        ArrivalOnDiffDate: true,
        layOver: false,
        cardInfo: [
          {
            arrival: {
              arrival: "Arrival",
              arrivalTime: "12:03 PM",
            },
          },
        ],
      },
    ],
  },
];

export const tripData = [
  {
    id: "5a44212c-9e39-4360-93b8-f6f152f8f0f2",
    cityName: "Pune, India",
    imageURL:
      "https://places.googleapis.com/v1/places/ChIJARFGZy6_wjsRQ-Oenb9DjYI/photos/AWYs27zAbJ8l9A3PjiJw2hFvUAQ2wkAlw2riPqNerohMSaUNGeT-z8vdg2vEgz9UY6lexCm5ftQyBKXCDSWdpbjM51Xg6K0Q_5CNHC5j-FupD82NJJILfOTQ9eO_zZp26CAzPIKvKPwObfigbcub_XHAeH7o1GdF1r3non5m/media?maxHeightPx=400&maxWidthPx=400&key=AIzaSyDwxGLXovmVwcR1lq_18claE3bu5lc3Y9w",
    checkFlag: false,
    city_name: "Pune",
    city_type: "city",
    locations: [],
    city_state: "Maharashtra",
    checkedFlag: true,
    description:
      "Discover Pune's rich history, cultural heritage, and modern charm through its iconic landmarks and local experiences",
    tripDetails: [
      {
        day: "Day 1",
        city_name: "Pune",
        day_itinerary_description: "Arrive in Pune and explore the heart of the city",
        itinerary_by_time_of_the_day: [
          {
            id: "bf8bef84-f27e-469c-aaa2-5854c208d7ac",
            description:
              "**Overnight Train Journey:** Board the train from Hyderabad to Pune, enjoying the scenic route through the Deccan Plateau",
            activity_type: "transportation.train",
            time_of_the_day: "morning",
            arrival_city_name: "Pune",
            arrival_city_state: "Maharashtra",
            departure_city_name: "Hyderabad",
            arrival_city_country: "India",
            departure_city_state: "Telangana",
            arrival_city_latitude: "18.5204",
            arrival_city_longitude: "73.8567",
            departure_city_country: "India",
            departure_city_latitude: "17.3850",
            departure_city_longitude: "78.4867",
            arrival_city_country_code: "IN",
            departure_city_country_code: "IN",
          },
          {
            id: "bea894f1-454c-4606-80aa-8277ea170730",
            description:
              "**Hotel Check-in and Rest:** Check into your comfortable hotel in the Koregaon Park area, known for its tree-lined streets and proximity to attractions",
            activity_type: "accommodation.hotel",
            time_of_the_day: "afternoon",
            accommodation_location_city: "Pune",
            accommodation_location_name: "Koregaon Park",
            accommodation_location_latitude: "18.5362",
            accommodation_location_longitude: "73.8961",
            accommodation_location_country_code: "IN",
          },
          {
            id: "54be9593-fcc3-4fd9-850c-e97a369da7e6",
            description:
              "**Osho Garden Visit:** Take a peaceful evening stroll through the serene Osho Teerth Park, enjoying its Japanese-style landscapes and meditation spaces",
            activity_type: "places.garden",
            time_of_the_day: "evening",
          },
        ],
        date: "2025-02-03",
      },
      {
        day: "Day 2",
        city_name: "Pune",
        day_itinerary_description: "Explore historical sites and local culture",
        itinerary_by_time_of_the_day: [
          {
            id: "a0a86309-c80e-40e0-bd61-3d8d92de4b63",
            description:
              "**Shaniwar Wada Visit:** Explore this historic fortification, once the seat of the Peshwa rulers, known for its architecture and tragic history",
            activity_type: "places.historical",
            time_of_the_day: "morning",
          },
          {
            id: "87632366-2167-4b6f-8211-8977ca13c2a0",
            description:
              "**Lal Mahal Tour:** Visit the historic palace where Chhatrapati Shivaji Maharaj spent his childhood",
            activity_type: "places.palace",
            time_of_the_day: "afternoon",
          },
          {
            id: "09f2f6e4-7cd8-414f-a0bc-0eb03ce4515c",
            description:
              "**Tulsi Baug Market:** Experience local shopping at this traditional market known for jewelry, clothing, and street food",
            activity_type: "places.market",
            time_of_the_day: "evening",
          },
        ],
        date: "2025-02-04",
      },
      {
        day: "Day 3",
        city_name: "Pune",
        day_itinerary_description: "Discover spiritual and natural attractions",
        itinerary_by_time_of_the_day: [
          {
            id: "6336ad5b-9670-47fa-a38f-0aa50299f2c0",
            description:
              "**Dagdusheth Ganpati Temple:** Visit one of India's most famous Ganesh temples, known for its spiritual significance",
            activity_type: "places.temple",
            time_of_the_day: "morning",
          },
          {
            id: "9d3586d1-8b77-47e9-8613-b070224c0d44",
            description:
              "**Pataleshwar Cave Temple:** Explore this 8th-century rock-cut temple dedicated to Lord Shiva",
            activity_type: "places.temple",
            time_of_the_day: "afternoon",
          },
          {
            id: "c194667d-4088-4c41-bebf-5424abe47a2c",
            description:
              "**Saras Baug:** Enjoy the evening at this beautiful park surrounding the Ganesh temple, perfect for relaxation",
            activity_type: "places.park",
            time_of_the_day: "evening",
          },
        ],
        date: "2025-02-05",
      },
      {
        day: "Day 4",
        city_name: "Pune",
        day_itinerary_description: "Final day exploring modern Pune",
        itinerary_by_time_of_the_day: [
          {
            id: "877e5948-24c5-437f-80bf-e8078b2709e4",
            description: "**Hotel Check-out:** Complete check-out formalities and store luggage",
            activity_type: "accommodation.checkout",
            time_of_the_day: "morning",
          },
          {
            id: "0c3d8b41-15a7-42f2-ac32-65a158276cee",
            description:
              "**Aga Khan Palace Visit:** Explore this historical monument and museum, significant for India's freedom movement",
            activity_type: "places.museum",
            time_of_the_day: "afternoon",
          },
          {
            id: "3d9943f9-63c8-422c-a204-9da8e5acf665",
            description: "**Return Journey:** Board your return train to Hyderabad, concluding your Pune adventure",
            activity_type: "transportation.train",
            time_of_the_day: "evening",
            arrival_city_name: "Hyderabad",
            arrival_city_state: "Telangana",
            departure_city_name: "Pune",
            arrival_city_country: "India",
            departure_city_state: "Maharashtra",
            arrival_city_latitude: "17.3850",
            arrival_city_longitude: "78.4867",
            departure_city_country: "India",
            departure_city_latitude: "18.5204",
            departure_city_longitude: "73.8567",
            arrival_city_country_code: "IN",
            departure_city_country_code: "IN",
          },
        ],
        date: "2025-02-06",
      },
    ],
    city_country: "India",
    city_latitude: "18.5204",
    city_itinerary: [],
    city_longitude: "73.8567",
    city_country_code: "IN",
    city_itinerary_description:
      "Discover Pune's rich history, cultural heritage, and modern charm through its iconic landmarks and local experiences",
    complete_itinerary_hotels_cost: {
      id: "476fe731-8074-45fb-861f-8c19461a4886",
      value: "$200",
      checkedFlag: true,
    },
    complete_itinerary_flights_cost: {
      id: "03696db3-e213-497c-b439-f842d03e73b6",
      value: "",
      checkedFlag: true,
    },
  },
];
export const selectedData = [
  {
    id: "c7240f73-88a4-4646-881d-32617d8a0e7c",
    cityName: "Pune, India",
    imageURL:
      "https://places.googleapis.com/v1/places/ChIJARFGZy6_wjsRQ-Oenb9DjYI/photos/AWYs27wxnEaZaAiIqur-GgoL8swin4EZjAh8Qn7OoDKT6D6QcP77kvfyttK4WkV71w9oaJPTnhqGMCFx8qVRLkGWySGPG_MiklhMXb-J66O9bvQyREhK1WBPVNkTAC3rTMlxhj30VdFzB7w8T_OIuYOJ96P0u95v9w0V-7Zq/media?maxHeightPx=400&maxWidthPx=400&key=AIzaSyDwxGLXovmVwcR1lq_18claE3bu5lc3Y9w",
    checkFlag: false,
    city_name: "Pune",
    city_type: "city",
    locations: [],
    city_state: "Maharashtra",
    checkedFlag: true,
    description:
      "Discover Pune's rich history, vibrant culture, and modern charm through its iconic landmarks and local experiences",
    tripDetails: [
      {
        day: "Day 1",
        city_name: "Pune",
        day_itinerary_description: "Train journey and arrival in Pune, followed by local exploration",
        itinerary_by_time_of_the_day: [
          {
            id: "42e3160c-968d-45c3-b879-cbf9f9e2716b",
            description:
              "**Train Journey:** Board your train from Hyderabad to Pune, enjoying the scenic route through the Deccan Plateau",
            activity_type: "transportation.train",
            time_of_the_day: "morning",
            arrival_city_name: "Pune",
            arrival_city_state: "Maharashtra",
            departure_city_name: "Hyderabad",
            arrival_city_country: "India",
            departure_city_state: "Telangana",
            arrival_city_latitude: "18.5204",
            arrival_city_longitude: "73.8567",
            departure_city_country: "India",
            departure_city_latitude: "17.3850",
            departure_city_longitude: "78.4867",
            arrival_city_country_code: "IN",
            departure_city_country_code: "IN",
          },
          {
            id: "51ee3614-37f9-41cc-9ef2-2d46bb5b8496",
            description: "**Hotel Check-in:** Settle into your comfortable accommodation in the heart of Pune",
            activity_type: "accommodation.hotel",
            time_of_the_day: "evening",
            accommodation_location_city: "Pune",
            accommodation_location_name: "Koregaon Park",
            accommodation_location_latitude: "18.5362",
            accommodation_location_longitude: "73.8975",
            accommodation_location_country_code: "IN",
          },
          {
            id: "9363fac9-e7a0-487b-8513-880c989f4e42",
            description:
              "**Evening Walk at MG Road:** Explore the bustling MG Road area, known for its shopping and dining options",
            activity_type: "places.shopping",
            time_of_the_day: "night",
          },
        ],
        date: "",
      },
      {
        day: "Day 2",
        city_name: "Pune",
        day_itinerary_description: "Exploring historical landmarks and cultural sites",
        itinerary_by_time_of_the_day: [
          {
            id: "af7d2360-b3bf-4c9e-bd55-545456816b60",
            description:
              "**Shaniwar Wada Visit:** Explore this historic fortification and former seat of the Peshwa rulers",
            activity_type: "places.historical",
            time_of_the_day: "morning",
          },
          {
            id: "51b05873-5188-4822-9747-3005951e55be",
            description:
              "**Aga Khan Palace Tour:** Visit this magnificent palace and learn about its significance in India's freedom movement",
            activity_type: "places.palace",
            time_of_the_day: "afternoon",
          },
          {
            id: "2c2ad775-822e-4a14-9bf2-d7523c034118",
            description: "**Osho Garden:** Relax in the serene atmosphere of the Japanese-style Osho Teerth Park",
            activity_type: "places.garden",
            time_of_the_day: "evening",
          },
        ],
        date: "",
      },
      {
        day: "Day 3",
        city_name: "Pune",
        day_itinerary_description: "Local culture and food exploration",
        itinerary_by_time_of_the_day: [
          {
            id: "ddf77f74-1636-4f24-92ba-6fd74077c279",
            description:
              "**Dagdusheth Ganpati Temple:** Visit this famous temple, one of Pune's most important religious sites",
            activity_type: "places.religious",
            time_of_the_day: "morning",
          },
          {
            id: "7a11dd12-a4bd-4764-b82b-e107ef20bf73",
            description: "**Lal Mahal:** Explore the historic red palace associated with Chhatrapati Shivaji Maharaj",
            activity_type: "places.historical",
            time_of_the_day: "afternoon",
          },
          {
            id: "29a48531-8b37-4338-ae61-9e8bfa794dd0",
            description: "**Food Tour in Old Pune:** Sample local delicacies in the bustling streets of old Pune",
            activity_type: "places.food",
            time_of_the_day: "evening",
          },
        ],
        date: "",
      },
      {
        day: "Day 4",
        city_name: "Pune",
        day_itinerary_description: "Final day exploration and departure",
        itinerary_by_time_of_the_day: [
          {
            id: "b8d84221-df2a-4bde-8085-0931a46922c6",
            description: "**Sinhagad Fort:** Take a morning trip to this historic mountain fortress",
            activity_type: "places.fort",
            time_of_the_day: "morning",
          },
          {
            id: "5167caad-d696-4fb3-9c24-3bb517d96a99",
            description: "**Hotel Check-out:** Complete check-out procedures and prepare for departure",
            activity_type: "accommodation.hotel",
            time_of_the_day: "afternoon",
          },
          {
            id: "6f686a21-0799-4342-a1aa-dd86c3e7f638",
            description: "**Train Journey:** Board your return train to Hyderabad",
            activity_type: "transportation.train",
            time_of_the_day: "evening",
            arrival_city_name: "Hyderabad",
            arrival_city_state: "Telangana",
            departure_city_name: "Pune",
            arrival_city_country: "India",
            departure_city_state: "Maharashtra",
            arrival_city_latitude: "17.3850",
            arrival_city_longitude: "78.4867",
            departure_city_country: "India",
            departure_city_latitude: "18.5204",
            departure_city_longitude: "73.8567",
            arrival_city_country_code: "IN",
            departure_city_country_code: "IN",
          },
        ],
        date: "",
      },
    ],
    city_country: "India",
    city_latitude: "18.5204",
    city_itinerary: [],
    city_longitude: "73.8567",
    city_country_code: "IN",
    city_itinerary_description:
      "Discover Pune's rich history, vibrant culture, and modern charm through its iconic landmarks and local experiences",
    complete_itinerary_hotels_cost: {
      id: "8614c0b6-6fcc-4856-816c-c95b398e3932",
      value: "$200",
      checkedFlag: true,
    },
    complete_itinerary_flights_cost: {
      id: "d255d669-e412-4e74-a55b-6ef65e73bf69",
      value: "",
      checkedFlag: true,
    },
  },
];

export const TEMP_TRIP_DETAILS_DATA = {
  day: "",
  city_name: "",
  day_itinerary_description: "",
  itinerary_by_time_of_the_day: [
    // {
    //   id: "4b98de08-ba0b-4e02-a54f-a9f3aa9f8000",
    //   time_of_the_day: "morning",
    //   description:
    //     "**International Flight to London:** Depart from Bengaluru International Airport to London Heathrow Airport",
    //   activity_type: "transportation.flight",
    //   departure_city_name: "Bengaluru",
    //   departure_city_state: "Karnataka",
    //   departure_city_country: "India",
    //   departure_city_country_code: "IN",
    //   departure_city_latitude: "12.9716",
    //   departure_city_longitude: "77.5946",
    //   arrival_city_name: "London",
    //   arrival_city_state: "Greater London",
    //   arrival_city_country: "United Kingdom",
    //   arrival_city_country_code: "GB",
    //   arrival_city_latitude: "51.5074",
    //   arrival_city_longitude: "-0.1278",
    // },
    // {
    //   id: "77f49052-37c7-442a-be5c-f445c28f58d7",
    //   time_of_the_day: "afternoon",
    //   description:
    //     "**Hotel Check-in and Rest:** Check into your comfortable hotel in Central London, freshen up and rest briefly to combat jet lag",
    //   activity_type: "accommodation.hotel",
    //   accommodation_location_name: "Westminster",
    //   accommodation_location_latitude: "51.4975",
    //   accommodation_location_longitude: "-0.1357",
    //   accommodation_location_city: "London",
    //   accommodation_location_country_code: "GB",
    // },
    // {
    //   id: "c82e1390-e784-4354-bbe8-dd97802067a1",
    //   time_of_the_day: "evening",
    //   description:
    //     "**Westminster Walking Tour:** Explore Big Ben, Houses of Parliament, and Westminster Abbey. **London Eye Experience:** Enjoy breathtaking views of London's skyline at sunset",
    //   activity_type: "places.landmarks",
    // },
    // {
    //   id: "972e003b-ac9d-4f7b-ab0d-919dde201856",
    //   time_of_the_day: "night",
    //   description:
    //     "**Dinner at Honest Burgers Westminster:** Enjoy gluten-free burgers and sides at this celiac-friendly restaurant",
    //   activity_type: "restaurant.british",
    // },
  ],
};

// const results = {
//   from: "Bengaluru, Karnataka, India",
//   hotels: "",
//   airlines: "",
//   trip_type: "roundtrip",
//   start_date: "",
//   from_latitude: "12.9716",
//   from_longitude: "77.5946",
//   number_of_days: "3",
//   arrival_airport: "",
//   number_of_rooms: "1",
//   number_of_stops: "",
//   hotel_refundable: "",
//   number_of_adults: "1",
//   budget_per_person: "2000",
//   departure_airport: "",
//   flight_refundable: "",
//   itinerary_version: "1",
//   accomadation_types: "hotel",
//   flight_cabin_class: "economy",
//   hotel_star_ratings: "3",
//   hotel_user_ratings: "6",
//   number_of_children: "0",
//   city_wise_itinerary: [
//     {
//       city_name: "Miami",
//       city_type: "city",
//       city_state: "Florida",
//       city_country: "United States",
//       city_latitude: "25.7617",
//       city_itinerary: [
//         {
//           day: "Day 1",
//           date: "2025-02-13",
//           city_name: "Miami",
//           day_itinerary_description: "Arrival and South Beach exploration",
//           itinerary_by_time_of_the_day: [
//             {
//               description:
//                 "**International Flight to Miami:** Depart from Bengaluru International Airport to Miami International Airport",
//               activity_type: "transportation.flight",
//               time_of_the_day: "morning",
//               arrival_city_name: "Miami",
//               arrival_city_state: "Florida",
//               departure_city_name: "Bengaluru",
//               arrival_city_country: "United States",
//               departure_city_state: "Karnataka",
//               arrival_city_latitude: "25.7617",
//               arrival_city_longitude: "-80.1918",
//               departure_city_country: "India",
//               departure_city_latitude: "12.9716",
//               departure_city_longitude: "77.5946",
//               arrival_city_country_code: "US",
//               departure_city_country_code: "IN",
//             },
//             {
//               description:
//                 "**Hotel Check-in:** Check into your hotel in South Beach area, perfectly located for exploring Miami's highlights",
//               activity_type: "accommodation.hotel",
//               time_of_the_day: "afternoon",
//               accommodation_location_city: "Miami",
//               accommodation_location_name: "South Beach",
//               accommodation_number_of_nights: "3",
//               accommodation_location_latitude: "25.7825",
//               accommodation_location_longitude: "-80.1340",
//               accommodation_location_country_code: "US",
//             },
//             {
//               description:
//                 "**Art Deco Walking Tour:** Explore the iconic Art Deco Historic District along Ocean Drive, featuring colorful 1920s and 1930s architecture. Approximately 1.5 hours walking tour.",
//               activity_type: "activity.walking_tour",
//               time_of_the_day: "evening",
//             },
//             {
//               description:
//                 "**Ocean Drive Dinner:** Enjoy a gluten-free dinner at one of the vibrant restaurants along Ocean Drive, followed by a stroll along the illuminated strip",
//               activity_type: "restaurant.american",
//               time_of_the_day: "night",
//             },
//           ],
//         },
//         {
//           day: "Day 2",
//           date: "2025-02-14",
//           city_name: "Miami",
//           day_itinerary_description: "Little Havana and cultural experiences",
//           itinerary_by_time_of_the_day: [
//             {
//               description:
//                 "**South Beach Morning:** Start your day with a relaxing beach session at South Beach. Perfect time for swimming and sunbathing",
//               activity_type: "activity.beach",
//               time_of_the_day: "morning",
//             },
//             {
//               description:
//                 "**Little Havana Tour:** Explore the vibrant Cuban neighborhood, visit Domino Park, and enjoy authentic Cuban culture. Watch cigar rollers and enjoy traditional music",
//               activity_type: "activity.cultural",
//               time_of_the_day: "afternoon",
//             },
//             {
//               description:
//                 "**Bayside Marketplace:** Visit this waterfront shopping and dining complex, perfect for sunset views of the marina",
//               activity_type: "activity.shopping",
//               time_of_the_day: "evening",
//             },
//             {
//               description:
//                 "**Miami Nightlife:** Experience Miami's famous nightlife at South Beach. Many venues offer gluten-free options",
//               activity_type: "activity.nightlife",
//               time_of_the_day: "night",
//             },
//           ],
//         },
//         {
//           day: "Day 3",
//           date: "2025-02-15",
//           city_name: "Miami",
//           day_itinerary_description: "Final day exploration and departure",
//           itinerary_by_time_of_the_day: [
//             {
//               description:
//                 "**Vizcaya Museum:** Visit this stunning Renaissance-style villa and gardens, one of Miami's most beautiful historical sites",
//               activity_type: "activity.museum",
//               time_of_the_day: "morning",
//             },
//             {
//               description: "**Hotel Check-out:** Check out from your hotel and store luggage",
//               activity_type: "accommodation.hotel",
//               time_of_the_day: "afternoon",
//             },
//             {
//               description: "**Return Flight:** Depart from Miami International Airport to Bengaluru",
//               activity_type: "transportation.flight",
//               time_of_the_day: "evening",
//               arrival_city_name: "Bengaluru",
//               arrival_city_state: "Karnataka",
//               departure_city_name: "Miami",
//               arrival_city_country: "India",
//               departure_city_state: "Florida",
//               arrival_city_latitude: "12.9716",
//               arrival_city_longitude: "77.5946",
//               departure_city_country: "United States",
//               departure_city_latitude: "25.7617",
//               departure_city_longitude: "-80.1918",
//               arrival_city_country_code: "IN",
//               departure_city_country_code: "US",
//             },
//           ],
//         },
//       ],
//       city_longitude: "-80.1918",
//       city_country_code: "US",
//       city_itinerary_description:
//         "Explore Miami's iconic beaches, art deco architecture, and vibrant Cuban culture over three exciting days",
//     },
//   ],
//   number_of_travelers: "1",
//   number_of_senior_citizens: "0",
//   complete_itinerary_description:
//     "Experience the vibrant culture of Miami with this action-packed 3-day itinerary. Explore the iconic South Beach, immerse yourself in the art deco district, enjoy the bustling nightlife, and discover the rich Cuban culture in Little Havana. The itinerary includes a perfect mix of beach time, cultural experiences, and historical sights.",
//   complete_itinerary_hotels_cost: "$450",
//   complete_itinerary_flights_cost: "$1200",
// };

export const DESTINATION_LIST_DATA = {
  city_name: "",
  city_state: "",
  city_country: "",
  city_country_code: "",
  city_type: "",
  city_latitude: "",
  city_longitude: "",
  city_itinerary_description: "",
  city_itinerary: [],
  cityName: "",
  description: "",
  tripDetails: [TEMP_TRIP_DETAILS_DATA, TEMP_TRIP_DETAILS_DATA, TEMP_TRIP_DETAILS_DATA],
  complete_itinerary_flights_cost: {
    value: "",
    checkedFlag: false,
    id: "a0ef972e-3649-4218-bfc7-750f5387b967",
  },
  complete_itinerary_hotels_cost: {
    value: "",
    checkedFlag: false,
    id: "758d266c-0e7e-4005-9b2b-2e3a35908222",
  },
  id: "",
  checkFlag: true,
  locations: [],
  imageURL: "",
  checkedFlag: true,
};

export const DESTINATION_LIST_DATA_GRID = {
  destination_name: "",
  destination_city: "",
  destination_country: "",
  destination_description: "",
  approximate_trip_cost: "",
  averagePackagePriceForExperiencing: "",
  description: "",
  id: "",
  checkFlag: false,
  locations: [],
  imageURL: "",
  checkedFlag: false,
};

export const CHAT_DATA = {
  result: "",
  messages: [],
  preText: "",
  postText: "",
  from: "",
  numberOfdays: "",
  cities: [],
  singleCity: false,
  city_wise_itinerary: [],
  fromCity: "",
  noOfDays: "",
  id: "",
  message: "",
  prompt: [],
  isUserMessage: false,
  isLoading: false,
  singleSelectedDestination: false,
  destinationList: [
    DESTINATION_LIST_DATA_GRID,
    DESTINATION_LIST_DATA_GRID,
    DESTINATION_LIST_DATA_GRID,
    DESTINATION_LIST_DATA_GRID,
  ],
  itinerary_version: "1",
};

export const SELECTED_CHAT_DATA: any = {
  result: "",
  messages: [],
  from: "",
  from_latitude: "",
  from_longitude: "",
  number_of_days: "",
  start_date: "",
  trip_type: "",
  number_of_travelers: "",
  number_of_adults: "",
  number_of_children: "",
  number_of_senior_citizens: "",
  flight_refundable: "",
  flight_cabin_class: "",
  number_of_stops: "",
  budget_per_person: "",
  number_of_rooms: "",
  hotel_refundable: "",
  hotel_star_ratings: "",
  airlines: "",
  hotels: "",
  departure_airport: "",
  arrival_airport: "",
  complete_itinerary_description: "",
  complete_itinerary_flights_cost: "",
  complete_itinerary_hotels_cost: "",
  itinerary_version: "",
  city_wise_itinerary: [],
  results: "",
  numberOfdays: 0,
  preText: "",
  postText: "",
  singleCity: true,
  cities: [],
  fromCity: "",
  noOfDays: "",
  id: "",
  message: "",
  prompt: [],
  isUserMessage: false,
  isLoading: false,
  singleSelectedDestination: true,
  destinationList: [DESTINATION_LIST_DATA],
  tripName: "",
};
export const flightData = [
  {
    date: "18-01-2025",
    airportCode: "IAD",
    airportName: "Wshington Dulles Interantional Airport",
    time: "10:05pm",
  },
];

export const flightDetails = [
  {
    transactionId: "123",
    departure: {
      airport: "BLR",
      airportName: "Bengaluru International Airport",
      date: "2025-02-08T10:25:00",
      flightNumber: "565",
      flyDuration: "4:05",
    },
    arrival: {
      airport: "LHR",
      airportName: "London Heathrow Airport",
      date: "2025-02-08T18:20:00",
      flightNumber: "3",
      flyDuration: "7:50",
    },
    airlinePnr: "123",
    totalTime: "11:55",
    stops: [
      {
        airport: "DXB",
        airportName: "Dubai International Airport",
        layover: "1:30",
        departureDate: "2025-02-08T14:30:00",
        arrivalDate: "2025-02-08T13:00:00",
        flyDuration: "7:50",
        flightNumber: "3",
        airline: {
          code: "EK",
          name: "Emirates Airlines",
          image: "1231",
        },
        operatingAirline: {
          code: "EK",
          name: "Emirates Airlines",
          image: "123",
        },
      },
    ],
    airline: {
      code: "EK",
      name: "Emirates Airlines",
      image: "123",
    },
    operatingAirline: {
      code: "EK",
      name: "Emirates Airlines",
      image: "123",
    },
  },
];

export const data = {
  from: "McLean, Virginia, United States",
  from_latitude: "38.9338",
  from_longitude: "-77.1773",
  number_of_days: "10",
  start_date: "2025-03-14",
  trip_type: "roundtrip",
  number_of_travelers: "1",
  number_of_adults: "1",
  flight_cabin_class: "economy",
  budget_per_person: "2000",
  number_of_rooms: "1",
  accommodation_types: "hotel",
  hotel_star_ratings: "3",
  complete_itinerary_description:
    "Experience the best of Greece through Athens, Santorini, and Mykonos. Start in historic Athens exploring ancient ruins, then sail to stunning Santorini for dramatic caldera views and sunsets. End in Mykonos with its iconic windmills and beautiful beaches before returning to Athens.",
  complete_itinerary_flights_cost: "$850",
  complete_itinerary_hotels_cost: "$700",
  itinerary_version: "1",
  city_wise_itinerary: [
    {
      city_name: "Athens",
      city_state: "Attica",
      city_country: "Greece",
      city_country_code: "GR",
      city_type: "city",
      city_latitude: "37.9838",
      city_longitude: "23.7275",
      city_itinerary_description: "Explore ancient ruins, historic neighborhoods, and vibrant culture in Athens",
      city_itinerary: [
        {
          day: "Day 1",
          city_name: "Athens",
          day_itinerary_description: "Arrival in Athens and settling in",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description:
                "**Flight to Athens:** Depart from Washington Dulles International Airport to Athens International Airport",
              activity_type: "transportation.flight",
              departure_city_name: "McLean",
              departure_city_state: "Virginia",
              departure_city_country: "United States",
              departure_city_country_code: "US",
              departure_city_latitude: "38.9338",
              departure_city_longitude: "-77.1773",
              arrival_city_name: "Athens",
              arrival_city_state: "Attica",
              arrival_city_country: "Greece",
              arrival_city_country_code: "GR",
              arrival_city_latitude: "37.9838",
              arrival_city_longitude: "23.7275",
            },
            {
              time_of_the_day: "evening",
              description:
                "**Check-in at Hotel:** Settle into your comfortable hotel in the historic Plaka neighborhood",
              activity_type: "accommodation.hotel",
              accommodation_number_of_nights: "3",
              accommodation_location_name: "Plaka",
              accommodation_location_latitude: "37.9709",
              accommodation_location_longitude: "23.7331",
              accommodation_location_city: "Athens",
              accommodation_location_country_code: "GR",
            },
          ],
        },
        {
          day: "Day 2",
          city_name: "Athens",
          day_itinerary_description: "Exploring ancient ruins and historical sites",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description:
                "**Acropolis Visit:** Explore the iconic Acropolis and Parthenon early to avoid crowds and heat",
              activity_type: "place.historical",
            },
            {
              time_of_the_day: "afternoon",
              description:
                "**Ancient Agora:** Walk through the ancient marketplace and visit the well-preserved Temple of Hephaestus",
              activity_type: "place.historical",
            },
            {
              time_of_the_day: "evening",
              description: "**Monastiraki Square:** Experience the vibrant atmosphere and shop at the flea market",
              activity_type: "place.shopping",
            },
          ],
        },
        {
          day: "Day 3",
          city_name: "Athens",
          day_itinerary_description: "Modern Athens exploration",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description: "**National Archaeological Museum:** Discover Greece's ancient treasures",
              activity_type: "place.museum",
            },
            {
              time_of_the_day: "afternoon",
              description: "**Syntagma Square:** Watch the changing of guards at the Parliament Building",
              activity_type: "place.landmark",
            },
          ],
        },
      ],
    },
    {
      city_name: "Santorini",
      city_state: "South Aegean",
      city_country: "Greece",
      city_country_code: "GR",
      city_type: "island",
      city_latitude: "36.3932",
      city_longitude: "25.4615",
      city_itinerary_description: "Experience stunning caldera views, sunsets, and charming villages",
      city_itinerary: [
        {
          day: "Day 4",
          city_name: "Santorini",
          day_itinerary_description: "Travel to Santorini and explore Fira",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description: "**Ferry to Santorini:** Take a scenic ferry ride from Athens to Santorini",
              activity_type: "transportation.ferry",
            },
            {
              time_of_the_day: "afternoon",
              description: "**Check-in at Hotel:** Settle into your hotel in Fira with caldera views",
              activity_type: "accommodation.hotel",
              accommodation_number_of_nights: "3",
              accommodation_location_name: "Fira",
              accommodation_location_latitude: "36.4166",
              accommodation_location_longitude: "25.4321",
              accommodation_location_city: "Santorini",
              accommodation_location_country_code: "GR",
            },
          ],
        },
      ],
    },
    {
      city_name: "Mykonos",
      city_state: "South Aegean",
      city_country: "Greece",
      city_country_code: "GR",
      city_type: "island",
      city_latitude: "37.4415",
      city_longitude: "25.3667",
      city_itinerary_description: "Enjoy beautiful beaches and iconic windmills",
      city_itinerary: [
        {
          day: "Day 7",
          city_name: "Mykonos",
          day_itinerary_description: "Travel to Mykonos and explore town",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description: "**Ferry to Mykonos:** Take a high-speed ferry from Santorini to Mykonos",
              activity_type: "transportation.ferry",
            },
            {
              time_of_the_day: "afternoon",
              description: "**Check-in at Hotel:** Settle into your hotel near Mykonos Town",
              activity_type: "accommodation.hotel",
              accommodation_number_of_nights: "3",
              accommodation_location_name: "Mykonos Town",
              accommodation_location_latitude: "37.4467",
              accommodation_location_longitude: "25.3289",
              accommodation_location_city: "Mykonos",
              accommodation_location_country_code: "GR",
            },
          ],
        },
        {
          day: "Day 10",
          city_name: "Athens",
          day_itinerary_description: "Return journey home",
          itinerary_by_time_of_the_day: [
            {
              time_of_the_day: "morning",
              description: "**Flight to Athens:** Short flight from Mykonos to Athens",
              activity_type: "transportation.flight",
            },
            {
              time_of_the_day: "afternoon",
              description: "**Return Flight:** Depart from Athens International Airport to Washington Dulles",
              activity_type: "transportation.flight",
              departure_city_name: "Athens",
              departure_city_state: "Attica",
              departure_city_country: "Greece",
              departure_city_country_code: "GR",
              departure_city_latitude: "37.9838",
              departure_city_longitude: "23.7275",
              arrival_city_name: "McLean",
              arrival_city_state: "Virginia",
              arrival_city_country: "United States",
              arrival_city_country_code: "US",
              arrival_city_latitude: "38.9338",
              arrival_city_longitude: "-77.1773",
            },
          ],
        },
      ],
    },
  ],
};

export const fareData = {
  fareRules: [
    {
      sector: "MAA-BOM",
      rules: {
        cancellation: "Cancellation Fee Applies",
        change: "Changes Fee Applies",
        baggage: {
          checkIn: "1 piece of 15 KG",
          cabin: "1 piece of 7 KG",
        },
      },
    },
    {
      sector: "BOM-MAA",
      rules: {
        cancellation: "Cancellation Fee Applies",
        change: "Changes Fee Applies",
        baggage: {
          checkIn: "1 piece of 15 KG",
          cabin: "1 piece of 7 KG",
        },
      },
    },
  ],
};

export const RECENT_TRAVELER_LIST = [
  {
    paxType: "ADT",
    gender: "female",
    leadPax: true,
    title: "Ms",
    firstName: "Jack",
    lastName: "Phawa",
    email: "heisarki.p@codematrix.org",
    countryCode: "1",
    mobileNumber: "(811) 900-4026",
    dateOfBirth: "1998-04-02",
    infantData: null,
    document: {
      type: "Passport",
      number: "sdf3ad3ad",
      nationality: "BE",
      issuedCountry: "BE",
      issuedDate: "2005-08-02",
      expiryDate: "2040-01-06",
    },
    operationalReference: {
      specialAssistance: "",
    },
    frequentFlyerinfo: {
      flyerNumber: "",
      frequentFlyerProgram: "",
      airline: "",
    },
    meals: [],
  },
  {
    paxType: "ADT",
    gender: "female",
    leadPax: true,
    title: "Ms",
    firstName: "Jon",
    lastName: "Phawa",
    email: "heisarki.p@codematrix.org",
    countryCode: "1",
    mobileNumber: "(811) 900-4026",
    dateOfBirth: "1998-04-02",
    infantData: null,
    document: {
      type: "Passport",
      number: "sdf3ad3ad",
      nationality: "BE",
      issuedCountry: "BE",
      issuedDate: "2005-08-02",
      expiryDate: "2040-01-06",
    },
    operationalReference: {
      specialAssistance: "",
    },
    frequentFlyerinfo: {
      flyerNumber: "",
      frequentFlyerProgram: "",
      airline: "",
    },
    meals: [],
  },
  {
    paxType: "ADT",
    gender: "female",
    leadPax: true,
    title: "Ms",
    firstName: "Heisarki",
    lastName: "Phawa",
    email: "heisarki.p@codematrix.org",
    countryCode: "1",
    mobileNumber: "(811) 900-4026",
    dateOfBirth: "1998-04-02",
    infantData: null,
    document: {
      type: "Passport",
      number: "sdf3ad3ad",
      nationality: "BE",
      issuedCountry: "BE",
      issuedDate: "2005-08-02",
      expiryDate: "2040-01-06",
    },
    operationalReference: {
      specialAssistance: "",
    },
    frequentFlyerinfo: {
      flyerNumber: "",
      frequentFlyerProgram: "",
      airline: "",
    },
    meals: [],
  },
];

export const ASK_ZOYA_DUMMY_PAYLOAD = {
  userId: "",
  messages: [],
  userInput: "can top give best top two flights with respect to less price",
  requestType: "askZoya",
  searchType: "flights",
  recordId: "",
};

export const data02 = {
  status: 404,
  message: "Flight availability failed.",
  error: "Not Found",
  details: {
    error: "Flight availability failed.",
  },
  data: {
    transactionId: "MK7Mc7oAw6uiAPs3_1",
    ttl: 30,
    fareId: "asdewfdsrdffdfd",
    international: true,
    extraServiceDetails: {
      seatsPreference: [
        {
          label: "Window",
          value: "W",
        },
        {
          label: "Aisle",
          value: "A",
        },
        {
          label: "Handicapped",
          value: "H",
        },
      ],
      mealsPreference: [
        {
          value: "CHML",
          label: "CHILD MEAL",
        },
        {
          value: "DBML",
          label: "DIABETIC MEAL",
        },
        {
          value: "GFML",
          label: "GLUTEN-FREE MEAL",
        },
        {
          value: "VGML",
          label: "VEGETARIAN MEAL (NON-DAIRY)",
        },
        {
          value: "VLML",
          label: "VEGETARIAN MEAL (LACTO-OVO)",
        },
        {
          value: "VOML",
          label: "VEGETARIAN ORIENTAL MEAL",
        },
      ],
      specialAssistance: [
        {
          value: "BSCT",
          label: "Bassinet Request for Infant",
        },
        {
          value: "WCHR",
          label: "Wheel Chair",
        },
      ],
      frequentFlyerProgram: [
        {
          airline: "united airlines",
          label: "Mileage Plus",
          value: "Mileage Plus",
        },
      ],
    },
  },
};

export const data012 = {
  status: 200,
  message: "Flight availability processed successfully.",
  data: {
    transactionId: "MK7Mc7oAw6uiAPs3_1",
    ttl: 30,
    fareId: "asdewfdsrdffdfd",
    international: true,
    extraServiceDetails: {
      seatsPreference: [
        {
          label: "Window",
          value: "W",
        },
        {
          label: "Aisle",
          value: "A",
        },
        {
          label: "Handicapped",
          value: "H",
        },
      ],
      mealsPreference: [
        {
          value: "CHML",
          label: "CHILD MEAL",
        },
        {
          value: "DBML",
          label: "DIABETIC MEAL",
        },
        {
          value: "GFML",
          label: "GLUTEN-FREE MEAL",
        },
        {
          value: "VGML",
          label: "VEGETARIAN MEAL (NON-DAIRY)",
        },
        {
          value: "VLML",
          label: "VEGETARIAN MEAL (LACTO-OVO)",
        },
        {
          value: "VOML",
          label: "VEGETARIAN ORIENTAL MEAL",
        },
      ],
      specialAssistance: [
        {
          value: "BSCT",
          label: "Bassinet Request for Infant",
        },
        {
          value: "WCHR",
          label: "Wheel Chair",
        },
      ],
      frequentFlyerProgram: [
        {
          airline: "united airlines",
          label: "Mileage Plus",
          value: "Mileage Plus",
        },
      ],
    },
  },
};
